import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import * as toastr from "toastr";
import * as moment from 'moment';

import { VisitasService } from '../../services/visitas.service';
import { Utilservice } from '@core/services/util.service';
import { ModalOutrasInfoComponent } from '../../components/modal-outras-info/modal.outras.info'


@Component({
  selector: 'app-controle',
  templateUrl: './controle.component.html',
  styleUrls: ['./controle.component.css']
})
export class ControleComponent implements OnInit {
  @ViewChild(ModalOutrasInfoComponent, {static:false})
  private ModalOutrasInfoComponent: ModalOutrasInfoComponent

  isRequestingGrid: boolean = false;
  isRequestingVendedor: boolean = false;
  isRequestingSetor: boolean = false;

  dateSelected: any;
  //data: boolean
  //periodo: boolean
  radio: boolean


  filters = {
    initialDate: moment().startOf('isoWeek').format('YYYY-MM-DD'),
    finalDate: moment().endOf('isoWeek').format('YYYY-MM-DD'),
    selectedSector: null,
    selectedVendedor: null,
    selectedStatusVisits: null,
    selectedFormaVisitaId: null,
    selectedFormaConsulta: null,
    selectedFormaVisita: null,
  }

  week = {
    start: moment().startOf('isoWeek'),
    end: moment().endOf('isoWeek'),
    formatedStart: moment().startOf('isoWeek').format('DD/MM/YYYY'),
    formatedEnd: moment().endOf('isoWeek').format('DD/MM/YYYY')
  };

  userLogado:{ id: number, nome: string, setor: string, idSetor: number, perfil: number};

	lsSetores:{id: number, codigo: string, idVendResp: number}[] = [];
	lsVendedores:{id: number, nome: string, setor: string, idSetor: number}[]= [];
	lsStatusVisitas = [];
  lsControle = [];
  lsSomatorioFormasVisitas:{id: number, nome: string, status: string, total: number}[] = [];

  lsFormasVisitas: any[] = [];

  constructor(
    private visitService: VisitasService,
    private router: Router
  ) {}

  ngOnInit() {
    
    this.getAllSetores();
    this.getFormasVisitas();

    this.visitService.getStatusVisita().subscribe(
      data => this.lsStatusVisitas = data,
      error => console.log(error),
      () => console.log('statusVisita Loaded'));

      let user = localStorage.getItem("user_logado");
      this.userLogado = JSON.parse(user);
    
      if(this.userLogado.perfil == 2) {
        const {selectedSector} = this.filters;
    
        this.visitService.getVendedoresPorSetor(this.userLogado.setor).subscribe(
          resp => {
            let respFiltered = resp.filter(e => e.id != 200); //tirando VAGO da lista
            this.lsVendedores = respFiltered;
            this.filters.selectedVendedor = null;
          }, error => console.log(error)
        );
      }

    
  }

  getAllSetores() {
    this.isRequestingSetor = true;
    this.visitService.getSetores().subscribe(
      data => {
        this.lsSetores = data;
      },
      error => console.log(error),
      () => this.isRequestingSetor = false,
    );
    console.log('Setores Loaded')
  }

  changeWeek(direction: string): void {
    const currentWeek = this.week;

    const date = direction == 'back' ?
      moment(currentWeek.start).subtract(7, 'd') : moment(currentWeek.end).add(1, 'd');

    this.week = {
      start: moment(date.startOf('isoWeek')),
      end: moment(date.endOf('isoWeek')),
      formatedStart: date.startOf('isoWeek').format('DD/MM/YYYY'),
      formatedEnd: date.endOf('isoWeek').format('DD/MM/YYYY')
    }

    this.filters.initialDate = date.startOf('isoWeek').format('YYYY-MM-DD');
    this.filters.finalDate = date.endOf('isoWeek').format('YYYY-MM-DD');
  }

  private actionsForSuccess(message: string){
    toastr.success(message);
  }

  private actionsForError(message: string){
      toastr.error(message);
  }

  onProximosCLientesClick(){
    const {initialDate, finalDate, selectedSector, selectedVendedor} = this.filters;

    const queryParams: any = {
			dataInicial:initialDate,
			dataFinal:finalDate,
			codigoGerencia: selectedSector.codigo,
    }

    if(selectedVendedor){
      queryParams.codigoVendedor = selectedVendedor.id;
    }

    this.router.navigate([`/visitas/controle/proximos`], {
      queryParams
    });
  }

	consultar(){
    const {
      initialDate,
      finalDate,
      selectedSector,
      selectedVendedor,
      selectedStatusVisits,
      selectedFormaVisitaId,
      selectedFormaConsulta
    } = this.filters;

    let dt_inicial = moment(initialDate);
    let dt_final = moment(finalDate);

    if(this.userLogado.perfil != 2 && !selectedSector) { //se for gestor preenchemos por padrao com seu setor
      this.actionsForError("Informe o setor");
      return;
    }

    if(!initialDate || !finalDate){
      this.actionsForError("Informe o período");
      return;
    }

    if(dt_final.isBefore(dt_inicial)){
      this.actionsForError("A data final precisa ser após ou igual a inicial");
      return;
    }

    let radioSelect = '';

    if(this.radio === true){
      radioSelect = 'periodo';
    }else{
      radioSelect = 'data';
    }
    const form: any = {
      dataInicial: initialDate,
      dataFinal: finalDate,
      setor: this.userLogado.perfil == 2 ? this.userLogado.setor : selectedSector.codigo, //cdfzs
      vendedorSetor: selectedVendedor ? selectedVendedor.setor : null,
      dateSelected: this.dateSelected,
      radioSelect: radioSelect,
      IdVisita: this.filters.selectedFormaVisita
    }

    if(selectedStatusVisits){
      form.status = selectedStatusVisits;
    }

    if(selectedFormaVisitaId){
      form.IdFormaVisita = selectedFormaVisitaId;
    }

    if(selectedFormaConsulta){
      form.IdConsulta = selectedFormaConsulta;
    }

    this.isRequestingGrid = true;

    this.visitService.consultarControleDeVisitasTodos(form).subscribe(
      data => {
        this.lsControle = data.visitas;
        this.lsControle.forEach(e=>e.cnpj = e.cnpj.toString())
      },
      error => console.log(error),
      () => this.isRequestingGrid = false
    );
	}

	clearForm(){
		this.filters = {
      initialDate: moment().startOf('isoWeek').format('YYYY-MM-DD'),
      finalDate: moment().endOf('isoWeek').format('YYYY-MM-DD'),
      selectedSector: null,
      selectedVendedor: null,
      selectedStatusVisits: null,
      selectedFormaVisitaId: null,
      selectedFormaConsulta: null,
      selectedFormaVisita: null
    }
	}

  cnpj(v) {
    return Utilservice.formatCnpj(v);
  }

  formatDate(date){
    return Utilservice.formatDate(date);
  }

  setModalInformations(item){
    this.ModalOutrasInfoComponent.setInformations(
      item.cnpj,
      item.razaoSocial,
      item.idCliente
    )
  }

  changeSector(e) {
    this.isRequestingVendedor = true;
    const {selectedSector} = this.filters;

    this.visitService.getVendedoresPorSetor(selectedSector.codigo).subscribe(
      resp => {
        let respFiltered = resp.filter(e => e.id != 200); //tirando VAGO da lista
        this.lsVendedores = respFiltered;
        this.filters.selectedVendedor = null;
      }, 
      error => console.log(error),
      () => this.isRequestingVendedor = false
    );
  }

  getFormasVisitas() {
    this.visitService.getFormasVisitasAtivas().subscribe(
      resp => {
        this.lsFormasVisitas = resp;
      },
      error => console.log(error)
    )
  }

  getDateSelected(event:any) {

    console.log(event.value)

  }

  print(){
    let radioSelect = '';

    if(this.radio === true){
      radioSelect = 'periodo';
    }else{
      radioSelect = 'data';
    }

    // let dt_inicial = moment(initialDate);
    // let dt_final = moment(finalDate);

    // if(this.userLogado.perfil != 2 && !selectedSector) { //se for gestor preenchemos por padrao com seu setor
    //   this.actionsForError("Informe o setor");
    //   return;
    // }

    // if(!initialDate || !finalDate){
    //   this.actionsForError("Informe o período");
    //   return;
    // }

    // if(dt_final.isBefore(dt_inicial)){
    //   this.actionsForError("A data final precisa ser após ou igual a inicial");
    //   return;
    // }

    // let radioSelect = '';

    // if(this.radio === true){
    //   radioSelect = 'periodo';
    // }else{
    //   radioSelect = 'data';
    // }
    // const form: any = {
    //   dataInicial: initialDate,
    //   dataFinal: finalDate,
    //   setor: this.userLogado.perfil == 2 ? this.userLogado.setor : selectedSector.codigo, //cdfzs
    //   vendedorSetor: selectedVendedor ? selectedVendedor.setor : null,
    //   dateSelected: this.dateSelected,
    //   radioSelect: radioSelect,
    //   IdVisita: this.filters.selectedFormaVisita
    // }

    const {
      initialDate,
      finalDate,
      selectedSector,
      selectedVendedor,
      selectedStatusVisits,
      selectedFormaVisitaId,
      selectedFormaConsulta
    } = this.filters;

    if(selectedVendedor == null){
      toastr.error("Selecione um representante");

      return;
    }

    if(radioSelect == "data"){

      if(!this.dateSelected){
        toastr.error("Selecione uma data");

        return;
      }
      
      let filter = {
        dataInicial: this.dateSelected,
        dataFinal: this.dateSelected,
        agent: selectedVendedor.idSetor,
        vendedorId: selectedVendedor.id
      }
      this.visitService.imprimirPlanejamento(filter).subscribe(
        response => {
          window.open(URL.createObjectURL(new Blob([response.blob()], { type: 'application/pdf' })), '', 'width=1000,height=900')
        },
        error => this.actionsForError("Não existem dados para imprimir")
      );
    }
    else if(radioSelect == "periodo"){
      let filter = {
        dataInicial: initialDate,
        dataFinal: finalDate,
        agent: selectedVendedor.idSetor,
        vendedorId: selectedVendedor.id
      }                   
      this.visitService.imprimirPlanejamento(filter).subscribe(
        response => {
          window.open(URL.createObjectURL(new Blob([response.blob()], { type: 'application/pdf' })), '', 'width=1000,height=900')
        },
        error => this.actionsForError("Não existem dados para imprimir")
      );
    }
    
  }

}
